import styled from 'styled-components';

export const ViewContainer = styled.div``;

export const ViewHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 30px;
`;

export const BackButton = styled.button`
  background: ${({ theme }) => theme.navActiveBg};
  border: none;
  color: ${({ theme }) => theme.heading};
  padding: 10px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.cardBorder};
  }
`;

export const ClientNameTitle = styled.h1`
  color: ${({ theme }) => theme.heading};
  margin: 0;
`;